module.exports = __webpack_public_path__ + "img/tataki.3356e082.jpg";